import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdateProduct = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  Style,
  productData= {}
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [status,setStatus] = useState(1);


  useEffect(() => {
    if(productData?.id){
      formik.setFieldValue("products",productData?.products);
      setStatus(productData?.status);
      // formik.setFieldValue("status",productData?.status);
    }

  },[])

  const validationSchema = yup.object({
    products: yup.string().required("This Field is Required"),
    // status: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      products: "",
      // status: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        parent_id: null,
        products: values.products,
        status: Number(status),
      };

      
      

      try {
        const url = productData?.id ? `products/update-product/${productData?.id}` : `products/add-product`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit) onSubmit(apiRes?.message || "Add Product successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Product Name */}

            <FeildWraper width="100%">
              <FormLabel required>Product</FormLabel>

              <input
                type="text"
                name="products"
                value={formik.values.products}
                onChange={formik.handleChange}
                placeholder="Product"
              />
              {formik.touched.products && formik.errors.products && (
                <FeildError>{formik.errors.products}</FeildError>
              )}
            </FeildWraper>

            {/* Status */}
            {/* <FeildWraper width="100%">
              <FormLabel required>Status</FormLabel>
              <select name="status" value={formik.values.status} onChange={formik.handleChange}>
                <option value="" disabled selected>
                  -- Select Product Status --
                </option>
                <option value="1">Active</option>
                <option value="0">InActive</option>
              </select>

              {formik.touched.status && formik.errors.status && (
                <FeildError>{formik.errors.status}</FeildError>
              )}
            </FeildWraper> */}
            {/* status */}
            <div className="w-full px-3 flex flex-col gap-2">
              <div>
                <p className="!text-sm !font-medium !leading-5  !text-[#1E2E54]">
                  Status
                </p>
              </div>
              <div className="flex gap-5 items-center text-sm">
                <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                  <input
                    type="radio"
                    name="status"
                    value="upload"
                    checked={status == 1}
                    onChange={() => setStatus(1)}
                  />
                  Active
                </label>

                <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                  <input
                    type="radio"
                    name="status"
                    value="url"
                    checked={status == 0}
                    onChange={() => setStatus(0)}
                  />
                  In Active
                </label>
              </div>
            </div>
            
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
           {productData?.id ?  "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateProduct;
